<div class="container-fluid p-1 mt-3">
  <q-reporting CodeBlock="BLO_REPORT_STAGE" [IdDonnee]="service.Stage.Ident" ></q-reporting>
</div>
